import { render, staticRenderFns } from "./widget-store-filter.vue?vue&type=template&id=b157a27c&scoped=true&"
import script from "./widget-store-filter.vue?vue&type=script&lang=js&"
export * from "./widget-store-filter.vue?vue&type=script&lang=js&"
import style0 from "./widget-store-filter.vue?vue&type=style&index=0&id=b157a27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b157a27c",
  null
  
)

export default component.exports